const API_ORIGIN = "https://be-cms.brunomd.com";
// const API_ORIGIN = "http://localhost:5253";
const API_BASE = `${API_ORIGIN}/dev/visioncare`;

export const backendUrl = (relativePath) =>
  relativePath ? `${API_ORIGIN}${relativePath}` : "";

export const ADMIN_KEY = "bvc-admin-9f3k7q2x8m5w";
const adminHeaders = (extra = {}) => ({ "x-admin-key": ADMIN_KEY, ...extra });

export const signup = async (formData) => {
  const res = await fetch(`${API_BASE}/HUBSIGn7k8Egs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      title: formData.title,
      firstname: formData.firstname,
      lastname: formData.lastname,
      email: formData.email,
      phone: formData.phone,
      date_of_birth: formData.date_of_birth,
      role: formData.role,
      npi_number: formData.npi_number,
      // practice_type: formData.practice_type,
      password: formData.password,
    }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Something went wrong");
  return data;
};

export const login = async (formData) => {
  const res = await fetch(`${API_BASE}/HUBLOGIN883jKqB`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Login failed.");
  return data;
};

// Admin-panel login — authenticates ONLY against the internal team
// (admins.json). Doctors cannot log in here.
export const adminLogin = async (formData) => {
  const res = await fetch(`${API_BASE}/HUBADMLGN63kx`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Login failed.");
  return data;
};

export const getUserDetails = async (email) => {
  const res = await fetch(`${API_BASE}/HUBUSRDT94vQz2x`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch user details");
  return data;
};

export const uploadAvatar = async (file, email) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("email", email);
  console.log("[API][uploadAvatar] Request:", {
    email,
    fileName: file?.name,
    fileType: file?.type,
    fileSize: file?.size,
  });
  const res = await fetch(`${API_BASE}/HUBAVTR82wXq3p`, {
    method: "POST",
    body: fd, // browser sets multipcccart Content-Type automatically
  });
  const data = await res.json();
  console.log("[API][uploadAvatar] Response:", data);
  if (!res.ok) throw new Error(data.message || "Avatar upload failed");
  return data;
};

export const trackResourceDownload = async ({
  email,
  resource_name,
  resource_url,
  resource_type,
  folder_name,
}) => {
  console.log("[API][trackResourceDownload] Request:", {
    email,
    resource_name,
    resource_url,
    resource_type,
    folder_name,
  });
  const res = await fetch(`${API_BASE}/HUBRDL73kLp9q`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email,
      resource_name,
      resource_url,
      resource_type,
      folder_name,
    }),
  });
  const data = await res.json();
  console.log("[API][trackResourceDownload] Response:", data);
  if (!res.ok) {
    throw new Error(data.message || "Failed to track resource download");
  }
  return data;
};

export const getResourceDownloadStats = async (email) => {
  console.log("[API][getResourceDownloadStats] Request:", { email });
  const res = await fetch(`${API_BASE}/HUBRDC41mNs2v`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  console.log("[API][getResourceDownloadStats] Response:", data);
  if (!res.ok) {
    throw new Error(data.message || "Failed to fetch resource stats");
  }
  return data;
};

export const getSpecialties = async () => {
  const res = await fetch(`${API_BASE}/HUBSPC56kRn8m`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch specialties");
  return data;
};

export const getYearsInPractice = async () => {
  const res = await fetch(`${API_BASE}/HUBYRS72bFp3w`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch years options");
  return data;
};

export const getPracticeTypes = async () => {
  const res = await fetch(`${API_BASE}/HUBPRC81dJq5h`);
  const data = await res.json();
  if (!res.ok)
    throw new Error(data.message || "Failed to fetch practice types");
  return data;
};

export const getFolders = async (specialty) => {
  const res = await fetch(
    `${API_BASE}/HUBFLD43sBx6t/${encodeURIComponent(specialty)}`,
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch folders");
  return data;
};

export const getTotalResources = async (specialty) => {
  console.log("[API][getTotalResources] Request:", { specialty });
  const res = await fetch(`${API_BASE}/HUBTRS55pLm1a`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ specialty }),
  });
  const data = await res.json();
  console.log("[API][getTotalResources] Response:", data);
  if (!res.ok)
    throw new Error(data.message || "Failed to fetch total resources");
  return data;
};

export const forgotPassword = async (email) => {
  const res = await fetch(`${API_BASE}/HUBFRG18mTz4c`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.message || "Failed to send OTP.");
  return data;
};

export const updateProfile = async (formData) => {
  const res = await fetch(`${API_BASE}/HUBUPD65nHj9k`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Update failed");
  return data;
};

export const verifyOtp = async ({ email, otp }) => {
  const res = await fetch(`${API_BASE}/HUBVOT37pXr2f`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp }),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.message || "Invalid OTP.");
  return data;
};

export const resetPassword = async ({ email, otp, newPassword }) => {
  const res = await fetch(`${API_BASE}/HUBRPW84qZw6b`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp, newPassword }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Password reset failed.");
  return data;
};

export const getFolderFiles = async (specialty, subfolder) => {
  const res = await fetch(
    `${API_BASE}/HUBFLD43sBx6t/${encodeURIComponent(specialty)}/${encodeURIComponent(subfolder)}/HUBSUB17wMq8`,
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch files");
  return data;
};

export const lookupNpi = async (npi) => {
  const res = await fetch(`${API_BASE}/npi-lookup?number=${npi}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "NPI lookup failed");
  return data;
};

// ── DrPortal submissions (sample kit orders + rep visit requests, unified) ──
export const submitSampleKitOrder = async (payload) => {
  const res = await fetch(`${API_BASE}/sample-kit-order`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to submit order");
  return data;
};

export const submitRepVisitRequest = async (payload) => {
  const res = await fetch(`${API_BASE}/HUBRVA73kP9wXm`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to submit request");
  return data;
};

// Single unified fetch — backend returns all submissions (optionally for one email).
// Pass a `type` to filter client-side; pass nothing to get everything.
export const listDrPortalSubmissions = async ({ email, type } = {}) => {
  const url = email
    ? `${API_BASE}/drportal-submissions?email=${encodeURIComponent(email)}`
    : `${API_BASE}/drportal-submissions`;
  const res = await fetch(url);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load submissions");
  const all = data.submissions || [];
  return type ? all.filter((s) => s.type === type) : all;
};

// Backwards-compatible wrappers used by existing components.
export const listSampleKitOrders = (email) =>
  listDrPortalSubmissions({ email, type: "sample-kit" });

// Rep visit requests are now stored as HubSpot tickets associated with the
// submitter's contact. Fetch them via the dedicated tickets endpoint instead
// of the legacy JSON store.
export const listRepVisitRequests = async (email) => {
  if (!email) return [];
  const url = `${API_BASE}/HUBRVL58sQ2vDx?email=${encodeURIComponent(email)}`;
  const res = await fetch(url);
  const data = await res.json();
  if (!res.ok)
    throw new Error(data.message || "Failed to load rep visit requests");
  return data.tickets || [];
};

// ── Team Management (HubSpot-backed) ──
export const addTeamMember = async (payload) => {
  const res = await fetch(`${API_BASE}/HUBTMA94vK8xr`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to add team member");
  return data;
};

export const listTeamMembers = async (parentEmail) => {
  const url = `${API_BASE}/HUBTML62nQ4dz?parentEmail=${encodeURIComponent(
    parentEmail,
  )}`;
  const res = await fetch(url);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load team members");
  return data.members || [];
};

export const updateTeamMember = async (payload) => {
  const res = await fetch(`${API_BASE}/HUBTMU38pR7sa`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update team member");
  return data;
};

export const removeTeamMember = async ({ email, parentEmail }) => {
  const res = await fetch(`${API_BASE}/HUBTMR59yJ2mc`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, parentEmail }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to remove team member");
  return data;
};

// ── Admin panel (HubSpot + local backed) ──

// All documents merged from HubSpot + the local backend (source-tagged).
export const adminListDocuments = async () => {
  const res = await fetch(`${API_BASE}/HUBADMDOCS83kQ7`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load documents");
  return data.documents || [];
};

// Pull all HubSpot documents into the backend (mirror). Manual trigger.
export const adminSyncDocuments = async () => {
  const res = await fetch(`${API_BASE}/HUBSYNCDOC91kSv2`, {
    method: "POST",
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Sync failed");
  return data;
};

// Only the real HubSpot folders (for the upload dropdown).
export const adminListFolders = async () => {
  const res = await fetch(`${API_BASE}/HUBADMFOLDERS73xK`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load folders");
  return data.folders || [];
};

// All rep-visit tickets (admin view).
export const adminListTickets = async () => {
  const res = await fetch(`${API_BASE}/HUBADMTKTS84nQ2`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load tickets");
  return data.tickets || [];
};

// Every registered user/contact.
export const adminListUsers = async () => {
  const res = await fetch(`${API_BASE}/HUBADMUSERS47nz5`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load users");
  return data.users || [];
};

// Edit a user / approve / reject. Pass { id }|{ email } plus `properties`.
export const adminUpdateUser = async ({ id, email, properties }) => {
  const res = await fetch(`${API_BASE}/HUBADMUSRU58mx2`, {
    method: "PATCH",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ id, email, properties }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update user");
  return data;
};

// Remove (archive) a user. Pass { id } or { email }.
export const adminDeleteUser = async ({ id, email }) => {
  const res = await fetch(`${API_BASE}/HUBADMUSRD92kq8`, {
    method: "DELETE",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ id, email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to delete user");
  return data;
};

// Upload a document — stored in HubSpot AND the backend. `folder` is the
// optional subfolder path under the main folder.
export const adminUploadDocument = async (file, folder = "") => {
  const fd = new FormData();
  fd.append("file", file);
  if (folder) fd.append("folder", folder);
  const res = await fetch(`${API_BASE}/HUBDOCUP47nQ8w`, {
    method: "POST",
    headers: adminHeaders(),
    body: fd,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Document upload failed");
  return data;
};

// ── Cal.com booking (headless) — lives in the dev/visioncare route ──
// List the bookable events (Book a Rep Visit, Attend a Meeting).
export const getCalEventTypes = async () => {
  const res = await fetch(`${API_BASE}/cal/event-types`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load events");
  return data.events || [];
};

// Available slots for an event between two dates (YYYY-MM-DD).
// Returns { "YYYY-MM-DD": [ { start }, ... ] } keyed by date.
export const getCalSlots = async ({ eventTypeId, start, end, timeZone }) => {
  const params = new URLSearchParams({
    eventTypeId: String(eventTypeId),
    start,
    end,
    timeZone,
  });
  const res = await fetch(`${API_BASE}/cal/slots?${params.toString()}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load slots");
  return data.slots || {};
};

// Create a booking. payload: { eventTypeId, eventTitle, start (ISO UTC),
// name, email, phone, timeZone, notes, guests:[] }
export const createCalBooking = async (payload) => {
  const res = await fetch(`${API_BASE}/cal/booking`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to create booking");
  return data.booking;
};

// Admin: live bookings pulled from Cal.com.
export const adminListCalBookings = async () => {
  const res = await fetch(`${API_BASE}/cal/admin-bookings`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load bookings");
  return data.bookings || [];
};

// ── Practice Assessment (lead-scoring quiz) ──
// Submit a completed assessment: { details, answers, fittingSet, score, grade }.
export const submitQuizAssessment = async (payload) => {
  const res = await fetch(`${API_BASE}/QUIZSUB7K2X9`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to submit assessment");
  return data;
};

// Admin: list every quiz submission (newest first). Needs the admin key.
export const adminListQuizSubmissions = async () => {
  const res = await fetch(`${API_BASE}/QUIZH7GIR353`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load submissions");
  return data.submissions || [];
};

// List all backend admins (password never returned).
export const adminListAdmins = async () => {
  const res = await fetch(`${API_BASE}/HUBADML29pXk4t`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load admins");
  return data.admins || [];
};

// Create a new admin. payload: { email, password, firstname, lastname }
export const adminCreateAdmin = async (payload) => {
  const res = await fetch(`${API_BASE}/HUBADMC73rTb6w`, {
    method: "POST",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to create admin");
  return data;
};

// Edit an existing admin (by email). payload: { email, password?, firstname?, lastname? }
export const adminUpdateAdmin = async (payload) => {
  const res = await fetch(`${API_BASE}/HUBADMU84vNc2s`, {
    method: "PATCH",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update admin");
  return data;
};

// Delete an admin (by email). payload: { email }
export const adminDeleteAdmin = async ({ email }) => {
  const res = await fetch(`${API_BASE}/HUBADMD91qWz5y`, {
    method: "DELETE",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to delete admin");
  return data;
};

// ── Cal Booking Email Recipients (doctor contacts) ──
// List all doctor recipients saved in admins.json calBookingEmails.
export const adminListBookingRecipients = async () => {
  const res = await fetch(`${API_BASE}/cal/booking-recipients`, {
    headers: adminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load recipients");
  return data.recipients || [];
};

// Add a new doctor recipient. payload: { name, email }
export const adminAddBookingRecipient = async (payload) => {
  const res = await fetch(`${API_BASE}/cal/booking-recipients`, {
    method: "POST",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to add recipient");
  return data;
};

// Remove a doctor recipient by email. payload: { email }
export const adminRemoveBookingRecipient = async ({ email }) => {
  const res = await fetch(`${API_BASE}/cal/booking-recipients`, {
    method: "DELETE",
    headers: adminHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to remove recipient");
  return data;
};
